export default (theme) => ({
  MuiInputAdornment: {
    positionEnd: {
      position: 'absolute',
      right: 8
    }
  },
  MuiFormLabel: {
    asterisk: {
      color: theme.palette.error.main
    }
  }
})
